module.exports = __webpack_public_path__ + "img/pengumuman.b94ec4d8.svg";